import AlertTypeEnum from "../enums/AlertTypeEnum";
import store from "../store";

export default {
    success: function (content) {
        store.commit('app/addAlert', {
            type: AlertTypeEnum.SUCCESS,
            content: content,
        });
    },
    warning: function (content) {
        store.commit('app/addAlert', {
            type: AlertTypeEnum.WARNING,
            content: content,
        });
    },
    error: function (content) {
        store.commit('app/addAlert', {
            type: AlertTypeEnum.ERROR,
            content: content,
        });
    },
    info: function (content) {
        store.commit('app/addAlert', {
            type: AlertTypeEnum.INFO,
            content: content,
        });
    },
}
